import {CommonModule} from '@angular/common';
import {
    ChangeDetectorRef,
    Component,
    ElementRef,
    EventEmitter,
    HostListener,
    Input,
    OnChanges,
    OnDestroy,
    Output
} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {firstValueFrom} from 'rxjs';
import html2canvas from 'html2canvas';
import {jsPDF} from 'jspdf';
import {EmpresaStateService} from '../../services/empresa-state.service';
import {
    DemonstrativoCliente,
    SankhyaGatewayService
} from '../../services/sankhya-gateway.service';
import {AuthService} from '../../services/auth.service';
import {LoadingIndicatorComponent} from '../../components/loading-indicator/loading-indicator.component';
import {LucideAngularModule, ZoomIn, ZoomOut} from 'lucide-angular';
import {
    MODELOS_COMPRA,
    ModeloCompra,
    COLUNAS_ITENS,
    CAMPOS_CABECALHO,
    ColunaCompra,
    ItemImpressaoCompra,
    itensCompra,
    numeroCompra,
    selecionarItensCompra
} from './compra-impressao.model';
interface FolhaCompra {
    itens: ItemImpressaoCompra[];
    fabricante: string;
    ultima: boolean;
}
@Component({
    selector: 'app-compra-impressao',
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        LoadingIndicatorComponent,
        LucideAngularModule
    ],
    templateUrl: './compra-impressao.component.html',
    styleUrls: [
        '../gpl-venda-impressao/gpl-venda-impressao.component.css',
        './compra-impressao.component.css'
    ]
})
export class CompraImpressaoComponent implements OnChanges, OnDestroy {
    @Input()
    view = 'impressao-pre-compra';
    @Input()
    modoModal = false;
    @Input()
    nunotaInicial: number | null = null;
    @Input()
    tipoInicial: string | null = null;
    @Output()
    fecharModal = new EventEmitter<void>();
    readonly ZoomIn = ZoomIn;
    readonly ZoomOut = ZoomOut;
    mostrarIrTopo = false;
    mostrarIrFinal = false;
    modelo: ModeloCompra = 'PRE_COMPRA_BRL';
    titulo = '';
    nunota = '';
    termo = '';
    fornecedoresBusca: DemonstrativoCliente[] = [];
    fornecedorSelecionado: DemonstrativoCliente | null = null;
    dropdownFornecedoresAberto = false;
    mensagemFornecedor = '';
    private fornecedorTimer: ReturnType<typeof setTimeout> | null = null;
    private fornecedorVersao = 0;
    de = this.dataInput(-30);
    ate = this.dataInput(0);
    buscando = false;
    carregando = false;
    exportando = false;
    erro = '';
    mensagemBusca = '';
    resultados: any[] = [];
    documento: any = null;
    itens: ItemImpressaoCompra[] = [];
    folhas: FolhaCompra[] = [];
    cabecalho: any = {};
    dataImpressao = '';
    orientacao: 'portrait' | 'landscape' = 'portrait';
    papel: 'a4' | 'letter' = 'a4';
    ordem = 'pn';
    zoom = 1;
    pb = true;
    options = {
        valores: true,
        dolar: true,
        barras: true,
        descricao: true,
        seriais: true,
        faturamento: true,
        entrega: true,
        pn: true,
        estoque: false,
        ordemPo: false,
        cotacao: false,
        observacaoItem: false,
        fabricante: false,
        condicao: true,
        cancelados: false,
        separarFabricante: false,
        codigo: false,
        status: false,
        abertos: false
    };
    colunasSelecionadas: Record<string, boolean> = {};
    camposSelecionados: Record<string, boolean> = {};
    readonly catalogoItens = COLUNAS_ITENS;
    get catalogoCabecalho(): ColunaCompra[] {
        const pedido = [
            'nunota',
            'solicitacao',
            'autorizacaoData',
            'autorizadorCodigo',
            'gplStatus',
            'numTitulo',
            'observacao',
            'posicaoParada',
            'usuario',
            'atualizacao',
            'empresa',
            'solicitanteCodigo',
            'solicitante',
            'autorizador',
            'inicioVenda',
            'terminoVenda',
            'tipoGpl',
            'prioridade',
            'geracao',
            'vendas',
            'preVendas',
            'descricaoSolicitante'
        ];
        return this.pedido
            ? CAMPOS_CABECALHO.filter((c) => pedido.includes(c.chave))
            : CAMPOS_CABECALHO.slice(0, 25);
    }
    private versao = 0;
    private buscaVersao = 0;
    private paginaVersao = 0;
    constructor(
        private gateway: SankhyaGatewayService,
        public empresa: EmpresaStateService,
        public auth: AuthService,
        private host: ElementRef<HTMLElement>,
        private cd: ChangeDetectorRef
    ) {}
    ngOnChanges(): void {
        const config =
            MODELOS_COMPRA.find((m) => m.view === this.view) ??
            MODELOS_COMPRA[0];
        const tipo = String(this.tipoInicial ?? '')
            .trim()
            .toUpperCase();

        if (this.view === 'impressao-pedido-compra') {
            this.modelo =
                tipo === 'IMPORTAÇÃO' ||
                tipo === 'IMPORTACAO' ||
                tipo === 'INTERNACIONAL'
                    ? 'INTERNACIONAL'
                    : 'PEDIDO_COMPRA';
        } else {
            this.modelo = config.modelo;
        }
        this.titulo = config.titulo;
        this.versao++;
        this.buscaVersao++;
        this.paginaVersao++;
        this.carregando = false;
        this.buscando = false;
        this.documento = null;
        this.folhas = [];
        this.resultados = [];
        this.termo = '';
        this.fornecedorSelecionado = null;
        this.fornecedoresBusca = [];
        this.dropdownFornecedoresAberto = false;
        this.fornecedorVersao++;
        if (this.fornecedorTimer) clearTimeout(this.fornecedorTimer);
        this.erro = '';
        this.nunota = '';
        this.ordem = this.pedido ? 'seq' : 'pn';
        this.orientacao = this.lista ? 'landscape' : 'portrait';
        this.options = {
            valores: true,
            dolar: true,
            barras: true,
            descricao: true,
            seriais: true,
            faturamento: true,
            entrega: true,
            pn: true,
            estoque: false,
            ordemPo: false,
            cotacao: false,
            observacaoItem: false,
            fabricante: this.pedido,
            condicao: true,
            cancelados: false,
            separarFabricante: false,
            codigo: false,
            status: false,
            abertos: false
        };
        this.colunasSelecionadas = Object.fromEntries(
            COLUNAS_ITENS.map((c) => [c.chave, !!c.padrao])
        );
        this.camposSelecionados = Object.fromEntries(
            CAMPOS_CABECALHO.map((c) => [c.chave, !!c.padrao])
        );
        if (this.pedido) this.camposSelecionados['observacao'] = true;
        const parametro = this.nunotaInicial
            ? String(this.nunotaInicial)
            : new URLSearchParams(location.search).get('NUNOTA') ||
            new URLSearchParams(location.search).get('nunota');
        if (parametro) {
            this.nunota = parametro;
            void this.abrir();
        }
    }
    get pedido(): boolean {
        return this.modelo === 'PEDIDO_COMPRA';
    }
    get lista(): boolean {
        return this.modelo === 'LISTA_GERAL';
    }
    get internacional(): boolean {
        return this.modelo === 'INTERNACIONAL';
    }
    get dolar(): boolean {
        return this.modelo === 'PRE_COMPRA_USD' || this.internacional;
    }
    get moeda(): string {
        return this.dolar ? 'U$' : 'R$';
    }
    get larguraMm(): number {
        return this.orientacao === 'portrait'
            ? this.papel === 'a4'
                ? 210
                : 215.9
            : this.papel === 'a4'
                ? 297
                : 279.4;
    }
    get alturaMm(): number {
        return this.orientacao === 'landscape'
            ? this.papel === 'a4'
                ? 210
                : 215.9
            : this.papel === 'a4'
                ? 297
                : 279.4;
    }
    get tituloDocumento(): string {
        return this.internacional
            ? 'PURCHASE ORDER'
            : this.pedido
                ? 'PEDIDO DE COMPRA'
                : this.lista
                    ? 'PRÉ-COMPRA (COTAÇÃO) — LISTA GERAL'
                    : `PRÉ-COMPRA (COTAÇÃO)${this.dolar ? ' — DÓLAR' : ''}`;
    }
    get resultadosFiltrados(): any[] {
        if (this.fornecedorSelecionado) {
            const fornecedor = this.fornecedorSelecionado;
            const documento = String(fornecedor.docparc ?? '').replace(
                /\D/g,
                ''
            );
            return this.resultados.filter((r) => {
                if (r.codparc && fornecedor.codparc)
                    return String(r.codparc) === String(fornecedor.codparc);
                if (documento)
                    return (
                        String(r.docparc ?? '').replace(/\D/g, '') === documento
                    );
                return (
                    String(r.fornecedor ?? '')
                        .trim()
                        .toLocaleLowerCase() ===
                    fornecedor.nomeparc.trim().toLocaleLowerCase()
                );
            });
        }
        const termo = this.termo.toLocaleLowerCase().trim();
        return this.resultados.filter(
            (r) =>
                !termo ||
                [r.nunota, r.fornecedor, r.docparc, r.comprador].some((v) =>
                    String(v ?? '')
                        .toLocaleLowerCase()
                        .includes(termo)
                )
        );
    }
    get colunas(): ColunaCompra[] {
        if (this.lista)
            return COLUNAS_ITENS.filter(
                (c) => this.colunasSelecionadas[c.chave]
            );
        const keys = ['seq'];
        if (this.pedido && this.options.codigo) keys.push('codprod');
        if (this.options.descricao) keys.push('descricao');
        if (!this.pedido && this.options.condicao) keys.push('condicao');
        if (this.options.pn) keys.push('pn');
        keys.push('qtd', 'unidade');
        if (this.options.fabricante) keys.push('fabricante');
        if (this.options.seriais && !this.pedido) keys.push('serial');
        if (this.options.estoque && !this.pedido) keys.push('estoque', 'local');
        if (this.options.observacaoItem && !this.pedido)
            keys.push('observacao');
        if (this.pedido && this.options.status) keys.push('status');
        if (!this.pedido && this.options.valores) {
            if (!this.dolar && this.options.dolar) keys.push('unitUsd');
            keys.push(
                this.dolar ? 'unitUsd' : 'unitBrl',
                this.dolar ? 'totalUsd' : 'totalBrl'
            );
        }
        return keys.map((k) => {
            const c = {...COLUNAS_ITENS.find((c) => c.chave === k)!};
            if (k === 'seq') c.titulo = 'Ord';
            if (k === 'unitUsd') {
                c.titulo = 'Valor U$';
                c.ingles = 'Price US$';
            }
            if (k === 'totalUsd') {
                c.titulo = 'Total U$';
                c.ingles = 'Total US$';
            }
            if (k === 'totalBrl') c.titulo = 'Total R$';
            if (k === 'qtd' && this.pedido) c.titulo = 'Comprar';
            return c;
        });
    }
    get camposGerais(): ColunaCompra[] {
        return this.catalogoCabecalho.filter(
            (c) => this.camposSelecionados[c.chave]
        );
    }
    get camposDocumento(): Array<{
        titulo: string;
        valor: string;
    }> {
        if (this.lista || this.pedido)
            return this.camposGerais
                .filter(
                    (c) =>
                        !(
                            this.pedido &&
                            (c.chave === 'observacao' || c.chave === 'nunota')
                        )
                )
                .map((c) => ({
                    titulo: c.titulo,
                    valor: this.formatar(this.cabecalho[c.chave], c)
                }));
        const c = this.cabecalho;
        const fields = [
            {
                titulo: this.internacional ? 'Date' : 'Emissão',
                valor: this.formatar(c.dtmov)
            },
            {titulo: 'Status', valor: this.formatar(c.gplStatus || c.status)},
            {
                titulo: this.internacional ? 'Type' : 'Tipo',
                valor: this.formatar(c.tipoGpl)
            },
            {
                titulo: this.internacional ? 'Title' : 'Nº Título',
                valor: this.formatar(c.numTitulo)
            },
            {
                titulo: this.internacional ? 'Payment terms' : 'Cond. pagto.',
                valor: this.formatar(this.documento.CONDICAO)
            }
        ];
        if (!this.internacional)
            fields.push({
                titulo: 'Categoria',
                valor: this.formatar(c.adCategoria)
            });
        if (this.options.ordemPo)
            fields.push({
                titulo: this.internacional ? 'Order' : 'Nº Ordem',
                valor: this.formatar(c.numOrdem)
            });
        if (this.options.ordemPo || this.internacional)
            fields.push({titulo: 'PO#', valor: this.formatar(c.numPo)});
        if (this.options.cotacao)
            fields.push({
                titulo: this.internacional ? 'Exchange rate' : 'Cotação dólar',
                valor: this.valor(c.vlrMoeda)
            });
        return fields;
    }
    voltarOuFechar(): void {
        if (this.modoModal) {
            this.fecharModal.emit();
            return;
        }
        this.documento = null;
        this.folhas = [];
        this.erro = '';
    }
    get indiceDocumento(): number {
        return this.resultadosFiltrados.findIndex(
            (r) => Number(r.nunota) === Number(this.nunota)
        );
    }
    navegarDocumento(direcao: number): void {
        const nota = this.resultadosFiltrados[this.indiceDocumento + direcao];
        if (nota) void this.abrir(nota.nunota);
    }
    @HostListener('scroll')
    atualizarRolagem(): void {
        const el = this.host.nativeElement;
        this.mostrarIrTopo = el.scrollTop > 100;
        this.mostrarIrFinal =
            el.scrollHeight - el.scrollTop - el.clientHeight > 100;
    }
    rolarImpressao(final: boolean): void {
        this.host.nativeElement.scrollTo({
            top: final ? this.host.nativeElement.scrollHeight : 0,
            behavior: 'smooth'
        });
    }
    larguraColuna(coluna: ColunaCompra): number {
        const peso = (c: ColunaCompra) =>
            c.chave === 'descricao' || c.chave === 'observacao'
                ? 3
                : c.chave === 'pn' || c.chave === 'fabricante'
                    ? 1.7
                    : c.chave === 'seq' || c.chave === 'unidade'
                        ? 0.6
                        : 1.2;
        return (
            (100 * peso(coluna)) / this.colunas.reduce((s, c) => s + peso(c), 0)
        );
    }
    get barras(): Array<{
        x: number;
        largura: number;
    }> {
        // Code 39 numérico (larguras estreita/larga 1:3), com início/fim e zonas de silêncio.
        const patterns = [
            'nnnwwnwnn',
            'wnnwnnnnw',
            'nnwwnnnnw',
            'wnwwnnnnn',
            'nnnwwnnnw',
            'wnnwwnnnn',
            'nnwwwnnnn',
            'nnnwnnwnw',
            'wnnwnnwnn',
            'nnwwnnwnn'
        ];
        const symbols = [
            'nwnnwnwnn',
            ...String(this.documento?.NUNOTA ?? '')
                .split('')
                .map((n) => patterns[Number(n)]),
            'nwnnwnwnn'
        ];
        let x = 10;
        const bars: Array<{
            x: number;
            largura: number;
        }> = [];
        for (const symbol of symbols) {
            for (let i = 0; i < symbol.length; i++) {
                const largura = symbol[i] === 'w' ? 3 : 1;
                if (i % 2 === 0) bars.push({x, largura});
                x += largura;
            }
            x++;
        }
        return bars;
    }
    get larguraBarras(): number {
        const last = this.barras.at(-1);
        return last ? last.x + last.largura + 10 : 100;
    }
    get semCotacao(): boolean {
        return (
            !!this.documento &&
            !(
                Number(
                    this.documento.compra?.vlrMoeda ?? this.documento.VLRMOEDA
                ) > 0
            )
        );
    }
    ngOnDestroy(): void {
        if (this.fornecedorTimer) clearTimeout(this.fornecedorTimer);
        this.fornecedorVersao++;
        this.versao++;
        this.buscaVersao++;
        this.paginaVersao++;
    }

    agendarBuscaFornecedores(): void {
        if (this.fornecedorTimer) clearTimeout(this.fornecedorTimer);
        this.fornecedorVersao++;
        this.fornecedorSelecionado = null;
        this.fornecedoresBusca = [];
        this.resultados = [];
        this.dropdownFornecedoresAberto = this.termo.trim().length >= 2;
        this.mensagemFornecedor = this.dropdownFornecedoresAberto
            ? 'Buscando fornecedores...'
            : '';
        if (this.dropdownFornecedoresAberto) {
            this.fornecedorTimer = setTimeout(
                () => void this.buscarFornecedores(),
                250
            );
        }
    }

    async buscarFornecedores(): Promise<void> {
        if (this.fornecedorTimer) clearTimeout(this.fornecedorTimer);
        if (this.termo.trim().length < 2) return;
        const version = ++this.fornecedorVersao;
        this.dropdownFornecedoresAberto = true;
        this.mensagemFornecedor = 'Buscando fornecedores...';
        try {
            const res = await firstValueFrom(
                this.gateway.buscarFornecedorPedidoCompra(this.termo.trim())
            );
            if (version !== this.fornecedorVersao) return;
            const body = res?.responseBody ?? res;
            this.fornecedoresBusca = (body as any)?.lista ?? [];
            this.mensagemFornecedor = this.fornecedoresBusca.length
                ? ''
                : 'Nenhum fornecedor encontrado.';
        } catch {
            if (version !== this.fornecedorVersao) return;
            this.fornecedoresBusca = [];
            this.mensagemFornecedor =
                'Não foi possível buscar fornecedores. Tente novamente.';
        }
    }

    labelFornecedor(fornecedor: DemonstrativoCliente): string {
        return [fornecedor.nomeparc, fornecedor.docparc]
            .filter(Boolean)
            .join(' - ');
    }

    selecionarFornecedor(fornecedor: DemonstrativoCliente): void {
        this.fornecedorVersao++;
        if (this.fornecedorTimer) clearTimeout(this.fornecedorTimer);
        this.fornecedorSelecionado = fornecedor;
        this.termo = this.labelFornecedor(fornecedor);
        this.dropdownFornecedoresAberto = false;
        void this.buscar();
    }

    buscarFiltroImpressao(): void {
        if (this.fornecedorSelecionado || !this.termo.trim())
            void this.buscar();
        else void this.buscarFornecedores();
    }

    @HostListener('document:click', ['$event'])
    fecharBuscaFornecedores(event: MouseEvent): void {
        if (!(event.target as HTMLElement)?.closest('.quick-sale-field')) {
            this.dropdownFornecedoresAberto = false;
        }
    }

    async buscar(): Promise<void> {
        if (
            !this.de ||
            !this.ate ||
            this.de > this.ate ||
            !this.empresa.codEmpReal
        ) {
            this.erro = 'Selecione a empresa e informe um período válido.';
            return;
        }
        const version = ++this.buscaVersao;
        this.buscando = true;
        this.erro = '';
        this.resultados = [];
        this.mensagemBusca = '';
        try {
            const top = this.pedido
                ? 1300
                : this.internacional
                    ? 1323
                    : 1301;

            const resposta: any = await firstValueFrom(
                this.gateway.listarPedidosCompra(
                    Number(this.empresa.codEmpReal),
                    this.de.split('-').reverse().join('/'),
                    this.ate.split('-').reverse().join('/'),
                    true,
                    '',
                    top
                )
            );
            if (version !== this.buscaVersao) return;
            const body = resposta?.responseBody ?? resposta;
            if (body?.sucesso === false || !Array.isArray(body?.lista))
                throw new Error(
                    body?.erro || 'Não foi possível consultar as compras.'
                );
            this.resultados = body.lista;
            this.mensagemBusca = this.resultados.length
                ? `${this.resultados.length} documento(s) no período.`
                : 'Nenhum documento encontrado no período.';
        } catch (error: any) {
            if (version === this.buscaVersao)
                this.erro = this.erroConsulta(error);
        } finally {
            if (version === this.buscaVersao) this.buscando = false;
        }
    }
    async abrir(numero = this.nunota): Promise<void> {
        if (
            !/^[1-9]\d*$/.test(String(numero).trim()) ||
            !Number.isSafeInteger(Number(numero))
        ) {
            this.erro = 'Informe uma NUNOTA válida.';
            return;
        }
        const version = ++this.versao;
        this.paginaVersao++;
        this.nunota = String(numero).trim();
        this.carregando = true;
        this.erro = '';
        this.documento = null;
        this.folhas = [];
        try {
            let modeloConsulta = this.modelo;
            let res: any;

            try {
                res = await firstValueFrom(
                    this.gateway.consultarCompraImpressao({
                        nunota: Number(numero),
                        modelo: modeloConsulta
                    })
                );
            } catch (error: any) {
                if (
                    error?.status === 422 &&
                    this.view === 'impressao-pedido-compra' &&
                    modeloConsulta === 'PEDIDO_COMPRA'
                ) {
                    modeloConsulta = 'INTERNACIONAL';
                    res = await firstValueFrom(
                        this.gateway.consultarCompraImpressao({
                            nunota: Number(numero),
                            modelo: modeloConsulta
                        })
                    );
                    this.modelo = modeloConsulta;
                } else {
                    throw error;
                }
            }

            if (version !== this.versao) return;
            if (!res?.sucesso || !res?.documento)
                throw new Error('Documento indisponível para impressão.');
            this.documento = res.documento;
            this.itens = itensCompra(this.documento);
            const c = this.documento.compra;
            this.cabecalho = {
                ...c,
                condicaoPagamento: this.documento.CONDICAO,
                moeda: this.moeda,
                total: c.vlrnota,
                empresa: c.empresa || this.documento.RAZAOSOCIAL,
                usuario: this.documento.USUARIO,
                solicitacao: c.dtmov,
                solicitante: c.solicitante,
                totalCore: this.itens.every((i) => i.coreBrl !== null)
                    ? this.itens.reduce((s, i) => s + (i.coreBrl ?? 0), 0)
                    : null
            };
            this.dataImpressao = new Date().toLocaleString('pt-BR');
            await this.atualizar();
        } catch (error: any) {
            if (version === this.versao) this.erro = this.erroConsulta(error);
        } finally {
            if (version === this.versao) this.carregando = false;
        }
    }
    async atualizar(): Promise<void> {
        if (!this.documento) return;
        const version = ++this.paginaVersao;
        if (!this.colunas.length) {
            this.folhas = [];
            return;
        }
        const cancelado =
            this.pedido &&
            !this.options.cancelados &&
            String(
                this.cabecalho.gplStatus || this.cabecalho.status
            ).toUpperCase() === 'CANCELADO';
        const itens = cancelado
            ? []
            : selecionarItensCompra(
                this.itens,
                this.pedido,
                this.options.cancelados,
                this.options.abertos,
                this.ordem
            );
        const grupos = new Map<string, ItemImpressaoCompra[]>();
        for (const item of itens) {
            const key =
                this.pedido && this.options.separarFabricante
                    ? item.fabricante || 'Fabricante não informado'
                    : '';
            if (!grupos.has(key)) grupos.set(key, []);
            grupos.get(key)!.push(item);
        }
        this.folhas = [...grupos].map(([fabricante, itens]) => ({
            fabricante,
            itens,
            ultima: true
        }));
        this.cd.detectChanges();
        await new Promise<void>((resolve) =>
            requestAnimationFrame(() => resolve())
        );
        if (version !== this.paginaVersao) return;
        const folhas: FolhaCompra[] = [];
        this.host.nativeElement
            .querySelectorAll<HTMLElement>('.paper')
            .forEach((paper, idx) => {
                const original = this.folhas[idx];
                const linhas = Array.from(
                    paper.querySelectorAll<HTMLElement>('tbody tr')
                );
                const header =
                    paper.querySelector<HTMLElement>(
                        '.report-header'
                    )!.offsetHeight;
                const totals =
                    paper.querySelector<HTMLElement>('.report-bottom')
                        ?.offsetHeight || 0;
                const tableHead =
                    paper.querySelector<HTMLElement>('thead')?.offsetHeight ||
                    25;
                const footer =
                    paper.querySelector<HTMLElement>(
                        '.report-footer'
                    )!.offsetHeight;
                const available =
                    ((this.alturaMm - 16) * 96) / 25.4 -
                    header -
                    tableHead -
                    footer -
                    32;
                let grupo: ItemImpressaoCompra[] = [],
                    altura = 0;
                linhas.forEach((row, index) => {
                    const height = row.offsetHeight + 1;
                    if (grupo.length && altura + height > available) {
                        folhas.push({
                            itens: grupo,
                            fabricante: original.fabricante,
                            ultima: false
                        });
                        grupo = [];
                        altura = 0;
                    }
                    grupo.push(original.itens[index]);
                    altura += height;
                });
                if (grupo.length && altura + totals > available) {
                    folhas.push({
                        itens: grupo,
                        fabricante: original.fabricante,
                        ultima: false
                    });
                    grupo = [];
                }
                folhas.push({
                    itens: grupo,
                    fabricante: original.fabricante,
                    ultima: true
                });
            });
        this.folhas = folhas;
        this.cd.detectChanges();
        this.atualizarRolagem();
        if (
            Array.from(
                this.host.nativeElement.querySelectorAll<HTMLElement>('.paper')
            ).some(
                (p) =>
                    p.offsetHeight > (this.alturaMm * 96) / 25.4 + 2 ||
                    p.scrollWidth > p.clientWidth + 2
            )
        ) {
            this.erro =
                'O conteúdo excedeu a página. Reduza as colunas ou altere a orientação antes de imprimir.';
            this.folhas = [];
        }
    }
    formatar(valor: any, coluna?: ColunaCompra): string {
        if (valor === undefined || valor === null || valor === '') return '—';
        if (coluna?.formato) {
            const n = numeroCompra(valor);
            return n === null
                ? '—'
                : n.toLocaleString(this.internacional ? 'en-US' : 'pt-BR', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: coluna.formato === 'numero' ? 4 : 2
                });
        }
        return String(valor);
    }
    valor(valor: any): string {
        return this.formatar(valor, {chave: '', titulo: '', formato: 'valor'});
    }
    converter(valor: any): number | null {
        const n = numeroCompra(valor),
            taxa = numeroCompra(
                this.documento?.compra?.vlrMoeda ?? this.documento?.VLRMOEDA
            );
        return this.dolar
            ? n !== null && taxa !== null && taxa > 0
                ? n / taxa
                : null
            : n;
    }
    get totais(): Array<{
        titulo: string;
        valor: any;
    }> {
        const c = this.documento?.compra ?? {};
        return [
            {
                titulo: this.internacional ? 'Freight' : 'Frete',
                valor: this.converter(c.vlrFrete)
            },
            {
                titulo: this.internacional
                    ? 'Other charges'
                    : 'Outras despesas',
                valor: this.converter(c.vlrOutros)
            },
            {
                titulo: this.internacional ? 'Discount' : 'Desconto',
                valor: this.converter(c.vlrDescTot)
            },
            {
                titulo: this.internacional ? 'Grand total' : 'Total geral',
                valor: this.converter(c.vlrnota)
            }
        ];
    }
    get coreTotal(): number | null {
        const key = this.dolar ? 'coreUsd' : 'coreBrl';
        return this.itens.every((i) => i[key] !== null)
            ? this.itens.reduce((s, i) => s + i[key], 0)
            : null;
    }
    async imprimir(): Promise<void> {
        if (!this.folhas.length || this.exportando) return;
        this.exportando = true;
        let iframe: HTMLIFrameElement | null = null;
        try {
            await this.atualizar();
            if (!this.folhas.length) return;
            iframe = document.createElement('iframe');
            iframe.style.cssText =
                'position:fixed;width:1px;height:1px;bottom:0;right:0;border:0;';
            document.body.appendChild(iframe);
            const doc = iframe.contentDocument!;
            doc.open();
            doc.write(
                '<!doctype html><html><head><title>Compra</title></head><body></body></html>'
            );
            doc.close();
            for (const style of Array.from(
                document.querySelectorAll('style,link[rel="stylesheet"]')
            ))
                doc.head.appendChild(style.cloneNode(true));
            const pageStyle = doc.createElement('style');
            pageStyle.textContent = `@page {size:${this.larguraMm}mm ${this.alturaMm}mm;margin:0} body,html{height:auto!important;overflow:visible!important;background:white!important} .paper{margin:0!important;box-shadow:none!important;break-after:page;zoom:1!important} .paper:last-child{break-after:auto}`;
            doc.head.appendChild(pageStyle);
            const clone = this.host.nativeElement.cloneNode(
                true
            ) as HTMLElement;
            clone.querySelectorAll('.no-print').forEach((e) => e.remove());
            doc.body.appendChild(clone);
            await Promise.all(
                Array.from(doc.images).map((i) =>
                    i.decode().catch(() => undefined)
                )
            );
            await doc.fonts.ready;
            iframe.contentWindow!.focus();
            iframe.contentWindow!.print();
            const frame = iframe;
            setTimeout(() => frame.remove(), 60000);
        } catch {
            iframe?.remove();
            this.erro = 'Não foi possível abrir a impressão. Tente novamente.';
        } finally {
            this.exportando = false;
        }
    }
    async gerarPdf(): Promise<void> {
        if (!this.folhas.length || this.exportando) return;
        this.exportando = true;
        this.erro = '';
        const zoomAnterior = this.zoom;
        try {
            this.zoom = 1;
            await this.atualizar();
            if (!this.folhas.length) return;
            await Promise.all(
                Array.from(this.host.nativeElement.querySelectorAll('img')).map(
                    (i) => i.decode().catch(() => undefined)
                )
            );
            const pdf = new jsPDF({
                orientation: this.orientacao,
                unit: 'mm',
                format: this.papel,
                compress: true
            });
            const papers = Array.from(
                this.host.nativeElement.querySelectorAll<HTMLElement>('.paper')
            );
            for (let i = 0; i < papers.length; i++) {
                const canvas = await html2canvas(papers[i], {
                    scale: 2,
                    backgroundColor: '#ffffff',
                    useCORS: true
                });
                // html2canvas não reproduz filter: grayscale; aplica o P/B também ao arquivo.
                if (this.pb) {
                    const ctx = canvas.getContext('2d')!;
                    const pixels = ctx.getImageData(
                        0,
                        0,
                        canvas.width,
                        canvas.height
                    );
                    for (let p = 0; p < pixels.data.length; p += 4) {
                        const gray = Math.round(
                            pixels.data[p] * 0.2126 +
                            pixels.data[p + 1] * 0.7152 +
                            pixels.data[p + 2] * 0.0722
                        );
                        pixels.data[p] =
                            pixels.data[p + 1] =
                                pixels.data[p + 2] =
                                    gray;
                    }
                    ctx.putImageData(pixels, 0, 0);
                }
                if (i) pdf.addPage(this.papel, this.orientacao);
                pdf.addImage(
                    canvas.toDataURL('image/png'),
                    'PNG',
                    0,
                    0,
                    this.larguraMm,
                    this.alturaMm,
                    undefined,
                    'FAST'
                );
            }
            pdf.save(`${this.modelo}-${this.nunota}.pdf`);
        } catch {
            this.erro = 'Não foi possível gerar o PDF. Tente novamente.';
        } finally {
            this.zoom = zoomAnterior;
            this.exportando = false;
        }
    }
    private erroConsulta(error: any): string {
        if (error?.status === 422) {
            return (
                error?.error?.detail ||
                error?.error?.erro ||
                error?.error?.message ||
                'A NUNOTA não pertence ao tipo de compra deste relatório.'
            );
        }

        if (error?.status === 404) {
            return 'Documento não encontrado.';
        }

        return (
            error?.error?.detail ||
            error?.error?.erro ||
            error?.error?.message ||
            (error?.status
                ? 'Não foi possível consultar o documento. Tente novamente.'
                : error?.message) ||
            'Falha na consulta.'
        );
    }
    private dataInput(dias: number): string {
        const data = new Date();
        data.setDate(data.getDate() + dias);
        return `${data.getFullYear()}-${String(data.getMonth() + 1).padStart(2, '0')}-${String(data.getDate()).padStart(2, '0')}`;
    }
}